module.exports = __webpack_public_path__ + "static/media/image_part_004.48d3f7b0.jpg";